import { ReduxThunkAction } from "../..";
import { mainSlice } from "./mainSlice";
import { ActiveUser, ListOfLocationsToAnalyst } from "./interfaces";
import { config } from "../../configVar";
import { gerenciaTecnicaSlice } from "../index";


// const serverUrl = window.location.hostname === 'localhost' ? 'http://localhost:3335' : 'https://api.field-data-lake.com';
// const serverUrl = 'https://api.well-whisper.com'
// const serverUrl = 'https://api.field-data-lake.com'
// const serverUrl = 'http://localhost:3335'
const serverUrl = config.serverUrl

const allowLogOut = false;

export const login =
    (email: string, password: string): ReduxThunkAction =>
        async (dispatch, getState) => {
            dispatch(mainSlice.actions.updateState({ status: true }));

            let result = [];

            try {
                const response = await fetch(`${serverUrl}/api/shared/login`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ email, password }),
                });

                const data = await response.json();

                const status = data?.status;

                if (status !== 200) {
                    dispatch(
                        mainSlice.actions.addToastNotification({
                            id: `${mainSlice.actions.addToastNotification.length + 1
                                }`,
                            message:
                                "No se pudo validar credenciales, favor de verificar tus credenciales",
                            type: "error",
                            duration: 5000,
                        })
                    );

                    dispatch(mainSlice.actions.updateState({ status: false }));
                    return;
                }

                const token = data.token;
                localStorage.setItem("authToken", token); // Store the token in local storage

                const activeUser: ActiveUser = {
                    id: data.id,
                    name: data.fullName,
                    email: data.email,
                    role: data.roles,
                };

                dispatch(mainSlice.actions.activeUser(activeUser));
                dispatch(mainSlice.actions.setconfigModules(data?.config?.modulesConfig));

                let users;

                if (
                    !getState().gerenciaTecnica?.users ||
                    (getState().gerenciaTecnica.users ?? []).length === 0
                ) {
                    const responseGetUsers = await fetch(
                        `${serverUrl}/api/shared/listOfUsers`,
                        {
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                authorization: `${data.token}`,
                            },
                        }
                    );

                    users = await responseGetUsers.json();
                    dispatch(gerenciaTecnicaSlice.actions.setUsers(users));
                }

            } catch (error) {
                dispatch(mainSlice.actions.activeUser());
                dispatch(
                    mainSlice.actions.addToastNotification({
                        id: `${mainSlice.actions.addToastNotification.length + 1}`,
                        message:
                            "No se pudo conectar al servidor, favor de intentar más tarde",
                        type: "error",
                        duration: 5000,
                    })
                );
                console.log({ error });
            }

            dispatch(mainSlice.actions.updateState({ status: false }));
        };

export const validateToken =
    (): ReduxThunkAction => async (dispatch, getState) => {
        dispatch(mainSlice.actions.updateState({ status: true }));

        // const serverUrl = process.env.NEXT_PUBLIC_BACK_HOST

        try {
            let token = localStorage.getItem("authToken");

            if (!token) {
                dispatch(mainSlice.actions.activeUser());
                return;
            }

            const response = await fetch(
                `${serverUrl}/api/shared/login-with-token`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        authorization: `${token}`,
                    },
                }
            );

            const data = await response.json();

            const status = data?.status;

            if (status !== 200) {
                localStorage.removeItem("authToken");
                dispatch(mainSlice.actions.activeUser());
                return;
            }

            const newToken = data.token;
            localStorage.setItem("authToken", newToken); // Store the token in local storage

            const activeUser: ActiveUser = {
                id: data.id,
                name: data.fullName,
                email: data.email,
                role: data.roles,
            };

            dispatch(mainSlice.actions.activeUser(activeUser));
            dispatch(mainSlice.actions.setconfigModules(data?.config?.modulesConfig));

            let users;

            if (
                !getState().gerenciaTecnica?.users ||
                (getState().gerenciaTecnica.users ?? []).length === 0
            ) {
                const responseGetUsers = await fetch(
                    `${serverUrl}/api/shared/listOfUsers`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            authorization: `${data.token}`,
                        },
                    }
                );

                users = await responseGetUsers.json();
                dispatch(gerenciaTecnicaSlice.actions.setUsers(users));
            }

        } catch (error) {
            dispatch(mainSlice.actions.activeUser());
            console.log({ error });
        } finally {
            dispatch(mainSlice.actions.updateState({ status: false }));
        }
    };

export const logout = (): any => async (dispatch: any, getState: any) => {
    localStorage.removeItem("authToken");
    dispatch(mainSlice.actions.activeUser());
};

export const getDepartmentInfo =
    (departmentId: string): ReduxThunkAction =>
        async (dispatch, getState) => {
            // const serverUrl = process.env.NEXT_PUBLIC_BACK_HOST

            dispatch(mainSlice.actions.updateState({ status: true }));

            try {
                let token = localStorage.getItem("authToken");

                if (!token) {
                    return;
                }

                const response = await fetch(
                    `${serverUrl}/api/workflow/GetDepartmentInformation?id=${departmentId}`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            authorization: `${token}`,
                        },
                    }
                );

                const data = await response.json();

                const status = response?.status;

                if (status === 401) {
                    localStorage.removeItem("authToken");
                    dispatch(mainSlice.actions.activeUser());
                    return;
                }

                if (status !== 200) {
                    console.log("Error");
                }

                const department = data;

                dispatch(mainSlice.actions.setActiveDepartment(department));
            } catch (error) {
                console.log({ error });
            } finally {
                dispatch(mainSlice.actions.updateState({ status: false }));
            }
        };